Ext.define('SA.view.sidebar.data.DataSearchResultsHeader', {
    alias: 'widget.data-search-results-header',
    extend: 'Ext.Component',

    cls: 'sa-data-search-results-header',

    initComponent() {
        this.callParent();

        this.update(this.getContentHtml());
    },

    getContentHtml() {
        var {enableClickableLeafPaths, path} = this,
            html = SA.view.VariablePathRenderer.render({cls: 'sa-data-search-results-header-path sa-data-search-results-header-link', path});

        if (enableClickableLeafPaths) {
            html += SA.Tags.html`<span class="sa-data-search-results-header-open-data-folder-link sa-data-search-results-header-link" data-path="${path}">open data folder</span>`;
        }

        return html;
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onLinkClick, this, {delegate: '.sa-data-search-results-header-link'});

        this.el.on('mouseover', this.onPathMouseOver, this, {delegate: '.sa-data-search-results-header-path'});
        this.el.on('mouseout', this.onPathMouseOut, this, {delegate: '.sa-data-search-results-header-path'});
    },

    onLinkClick(ev, target) {
        var {dataset} = this,
            path = target.getAttribute('data-path');

        if (!this.shouldIgnorePathMouseEventForEl(target)) {
            this.fireEvent('click:path', path, dataset);
        }
    },

    onPathMouseOut(ev, target) {
        Ext.fly(target).removeCls('sa-data-search-results-header-path-over');
    },

    onPathMouseOver(ev, target) {
        if (!this.shouldIgnorePathMouseEventForEl(target)) {
            Ext.fly(target).addCls('sa-data-search-results-header-path-over');
        }
    },

    shouldIgnorePathMouseEventForEl(pathEl) {
        var isLeafPathEl = !Ext.fly(pathEl.parentElement).hasCls('sa-data-search-results-header-path');

        return isLeafPathEl && !this.enableClickableLeafPaths;
    }
});